import type { TFunction } from 'i18next';
import { ApiError } from './api';

/** Map an API error to a translated, user-facing message. */
export function describeError(err: unknown, t: TFunction): string {
  if (err instanceof ApiError) {
    if (err.status === 0) return t('errors.network');
    if (err.status === 403) return t('errors.forbidden');
    if (err.status === 404) return t('errors.notFound');
    if (err.status === 409) return t('errors.conflict');
    if (err.code === 'validation_error') return t('errors.validation');
    return err.message || t('errors.generic');
  }
  return t('errors.generic');
}
